import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CarsService} from '../../cars.service';
import {GooglePlaceDirective} from 'ngx-google-places-autocomplete';
import {NbDialogRef, NbDialogService} from '@nebular/theme';
import {faCartPlus, faGlobe, faLock} from '@fortawesome/free-solid-svg-icons';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {ImageDialogComponent} from '../../image-dialog/image-dialog.component';
import {MatDialog} from '@angular/material/dialog';
// import {ThankYouDialogComponent} from './thank-you-dialog.component';
import {MessageService} from 'primeng/api';
import {map} from 'rxjs/operators';
import * as moment from 'moment';
import {ConfirmationSaveDialogComponent} from './confirmation-save.component';
import {round} from 'lodash';
import {MatTableDataSource} from '@angular/material/table';
import {TaxExpense} from '../../editable-list/list-item.model';
import {selectLoginState} from '../../../auth/loginModal/selectors/login.selectors';
import {Store} from '@ngrx/store';
import {AppState} from '../../../reducers';
import {CurrencyService} from '../../../services/currency.service';

const INITIAL_DATA: TaxExpense[] = [
  { name: 'הובלה מחוץ לנמל', value: 0 },
  { name: 'תקינה', value: 0 },
  { name: 'שמאות', value: 0 },
  { name: 'דמי תיווך', value: 0 }
];

@Component({
  selector: 'app-my-car-modal',
  templateUrl: './my-car-modal.component.html',
  styleUrls: ['./my-car-modal.component.scss'],
  providers: [MessageService]
})
export class MyCarModalComponent implements OnInit, OnDestroy {

  loginStatus$: Observable<any>;
  user: any;

  constructor(private _fb: FormBuilder,
              private messageService: MessageService,
              // private pricesService: PricesService,
              private carService: CarsService,
              // private store: Store<AppState>,
              public nbDialogRef: NbDialogRef<MyCarModalComponent>,
              public dialog: MatDialog,
              public dialogService: NbDialogService,
              private store: Store<AppState>,
              public currencyService: CurrencyService,
  ) {
  }



  /*** tax expenses ***/
  displayedColumns: string[] = ['name', 'value', 'actions'];
  dataSource = new MatTableDataSource<TaxExpense>(INITIAL_DATA);
  taxList: TaxExpense[] = [...INITIAL_DATA];

  // addRow() {
  //   const newRow: TaxExpense = { name: '', value: null };
  //   this.dataSource.data = [...this.dataSource.data, newRow];
  // }
  //
  // removeRow(index: number) {
  //   const data = this.dataSource.data;
  //   data.splice(index, 1);
  //   this.dataSource.data = data;
  // }

  /*** end tax expenses ***/

  get f() {
    return this.carForm.controls;
  }

  isPercent: boolean;
  isLoading = true;
  faCartPlus: any = faCartPlus;

  @Input() isLoadingCalc: BehaviorSubject<boolean>;
  isLoadingCalcSubscription: Subscription;
  loaded = true;

  // @Input() vehicleValue: BehaviorSubject<number>;
  // vehicleValueSubscription: Subscription;
  // calculatedPrice: number;

  data: any;
  source: 'commercial' | 'personal' | 'individual' = 'individual';
  selection: 'commercial' | 'personal' | 'none' = 'none';
  currencies: any;
  mode: string;
  countries: any[];
  exwCountries: any[] = [];
  fcaCountries: any[] = [];
  countriesOnDisplay: any[] = [];
  fcaCountriesOnDisplay: any[] = [];
  price: any;
  carForm: FormGroup;
  harbors: any[] = [];
  photos: any[] = [];
  // countries: any[];
  // @ViewChild(FileUploadComponent, {static: false}) fileUploadComponent: FileUploadComponent;
  // @ViewChild('fileUploadComponent') fileUploadComponent: FileUploadComponent;
  dialogRef: NbDialogRef<MyCarModalComponent>;


  shipmentMethods: any[] = [];
  currencies$: Observable<any[]>;

  doorNumbers: number[] = Array.from({length: 6}, (_, i) => i + 1);
  seatNumbers: number[] = Array.from({length: 11}, (_, i) => i + 1);
  // userFile: FileUpload | null = null;
  // additionalFiles: FileUpload[] = [];
  // files: CarPhotoModel[] = [];

  faGlobe: any = faGlobe;
  // exw
  exwRates: any[] = [];
  exwSelectedCountry: any = '';
  exwSelectedCity: any = '';
  exwConfig = {countries: [], cities: [], harbors: []};
  exwCities: any[] = [];
  exwSelectFromGoogleCity: boolean = false;
  fcaSelectFromGoogleCity: boolean = false;
  fcaSelectedCountry: any = '';
  fcaSelectedHarbor: any = '';
  fcaHarbors: any[] = [];

  selectedCurrency: any;
  selectedCfrCurrency: any;
  myIsPCTSubscription: Subscription;
  myCarPriceSubscription: Subscription;

  placesOptions = {
    types: ['(cities)'],
    // componentRestrictions: {country: 'IL'}
  };
  @ViewChild('placesRef') placesRef: GooglePlaceDirective;

  protected readonly faLock = faLock;


  calculatedValueForCustomer: number;
  formChanged = false;

  onToggleChange(event) {
    this.formChanged = true;
    this.isPercent = event;
    this.carForm.get('MyCarPrice').patchValue(0);
  }


  onRateChange($event: any): void {
    console.log($event);
    this.carForm.get('RateType')?.patchValue($event);


    // clear all values
    this.carForm.get('ExwCity')?.patchValue(null);
    this.carForm.get('ExwRateId')?.patchValue(null);
    this.carForm.get('Country')?.patchValue(null);
    this.carForm.get('FcaRateId')?.patchValue(null);
    this.carForm.get('FcaDischargeHarbor')?.patchValue(null);
    this.carForm.get('FcaHarbor')?.patchValue(null);
    this.carForm.get('CfrType')?.patchValue(null);
    this.carForm.get('CfrPrice')?.patchValue(null);
    this.carForm.get('CfrCurrencyType')?.patchValue(null);
    this.carForm.get('CfrImportType')?.patchValue(null);
    this.fcaSelectedCountry = '';
    this.exwSelectedCountry = '';
    if ($event === 'FCA') {

      this.fcaCountriesOnDisplay = this.fcaCountries;

    } else if ($event === 'EXW') {
      this.countriesOnDisplay = this.exwCountries;
    }
  }

  openDialog(index: number): void {
    this.dialog.open(ImageDialogComponent, {
      data: {
        images: this.data.Files,
        currentIndex: index
      },
      panelClass: 'bounce-dialog'
    });
  }

  closeDialog(): void {
    this.nbDialogRef.close();
  }

  ngOnInit() {

    this.currencyService.ensureLoaded();
    this.formChanged = this.selection === 'none';

    this.taxList = [...INITIAL_DATA];


    this.loginStatus$ = this.store.select(selectLoginState).pipe(map(loginState => {
      this.user = loginState.userData;
      if (loginState.isLogin) {
          if (loginState.userData.role.includes('personal_importer_mediator')) {
              this.source = 'personal';
          }
        else if (loginState.userData.role.includes('commercial_importer')) {
          this.source = 'commercial';
          }
        else {
              this.source = 'individual';
          }

        } else {
          this.source = 'individual';
        }
    }));

    this.loginStatus$.subscribe(() => { });

    this.exwRates = this.exwCountries;
    this.carForm = this.createCarForm();
    // this.initializeTableRows();
    this.exwSelectedCountry = this.data?.Rate?.country ?? '';
    this.fcaSelectedCountry = this.data?.Rate?.country ?? '';
    this.countriesOnDisplay = this.exwCountries;
    this.fcaCountriesOnDisplay = this.fcaCountries;
    this.selectedCurrency = this.data?.CurrencyType ?? '';
    this.selectedCfrCurrency = this.data?.Rate?.cfrCurrencyType ?? '';

    this.calculateValue();

    this.carForm.valueChanges.subscribe(value => {
      this.formChanged = true;
    });

    this.carForm.get('MyIsPCT').valueChanges.subscribe(() => {
      this.formChanged = true;
      this.calculateValue();
    });

    this.carForm.get('MyCarPrice').valueChanges.subscribe(() => {
      this.formChanged = true;
      this.calculateValue();
    });


    this.isLoading = false;

    // this.vehicleValueSubscription = this.vehicleValue.subscribe((value: any) => {
    //   // Do something with the value
    //   if (value) {
    //     this.calculatedPrice = value.value;
    //     this.calculateValue();
    //   }
    // });

    // this.isLoadingCalcSubscription = this.isLoadingCalc.subscribe(loading => {
    //   // Do something with the value
    //   this.loaded = !loading;
    //   if (!loading) {
    //     console.log('modal ready to calc');
    //   }
    // });
  }

  // get importSelection(): string {
  //   switch (this.selection) {
  //     case 'commercial':
  //       return 'מסחרי';
  //     case 'personal':
  //       return 'פרטי';
  //     default:
  //       return '';
  //   }
  // }
  get importSelection(): string {
    switch (this.selection) {
        case 'commercial':
            return 'מסחרי';
        case 'personal':
            return 'אישי';
        default:
            return '';
    }
  }

  ngOnDestroy() {
    // this.vehicleValueSubscription.unsubscribe();
    this.isLoadingCalcSubscription?.unsubscribe();
    this.myIsPCTSubscription?.unsubscribe();
    this.myCarPriceSubscription?.unsubscribe();


  }

  createCarForm() {
    const id = this.data ? this.data.id || '' : '';
    const filesArray = this.data && this.data.Files ? this._fb.array(this.data.Files) : this._fb.array([]);
    const mainFile = this.data && this.data.Files && this.data.Files.length > 0
      ? this.data.Files.find(file => file.isMain)?.title || ''
      : '';

    this.selection = this.data.MySelection || 'none';
    this.source = this.source !== 'individual' ? this.data.MySource || this.source : this.source;
    this.taxList = this.data?.MyTaxList != null ? JSON.parse(this.data?.MyTaxList) : INITIAL_DATA;

    this.formChanged = this.selection === 'none';

    return this._fb.group({
      id: [id],
      Manufacturer: [this.data?.Manufacturer ?? '', Validators.required],
      Model: [this.data?.Model ?? '', Validators.required],
      FinishLevel: [this.data?.FinishLevel ?? ''],
      TotalWeight: [this.data?.TotalWeight ?? ''],
      ManufactureDate: [this.formatDate(this.data?.ManufactureDate ?? '')],
      CarStatus: [this.data?.CarStatus ?? ''],
      FirstUseDate: [this.formatDate(this.data?.FirstUseDate ?? '')],
      Mileage: [this.data?.Mileage ?? ''],
      SaleCondition: [this.data?.SaleCondition ?? ''],
      Port: [this.data?.Port ?? ''],
      OverlandDeliveryPrice: [this.data?.OverlandDeliveryPrice ?? ''],
      PickupLocation: [this.data?.PickupLocation ?? ''],
      CertificateOfOrigin: [this.data?.CertificateOfOrigin ?? 'No'],
      Location: [this.data?.Location ?? ''],
      ExteriorColor: [this.data?.ExteriorColor ?? ''],
      UpholsteryColor: [this.data?.UpholsteryColor ?? ''],
      FuelType: [this.data?.FuelType ?? ''],
      NumberOfDoors: [this.data?.NumberOfDoors ? parseInt(this.data.NumberOfDoors, 0) : null],
      NumberOfSeats: [this.data?.NumberOfSeats ? parseInt(this.data.NumberOfSeats, 0) : null],
      CarPrice: [this.data?.CarPrice ?? '', Validators.required],
      CurrencyType: [this.data?.CurrencyType ?? '', Validators.required],
      Notes: [this.data?.Notes ?? ''],
      MainFile: [mainFile],
      Status: [this.data?.Status ?? ''],
      Files: filesArray,
      PollutionRank: [this.data?.PollutionRank ?? '4'],
      EquipLevel: [this.data?.EquipLevel ?? '4'],

      // rate data
      RateId: [this.data?.id ?? ''],
      RateType: [this.data?.Rate?.type ?? ''],
      Country: [this.data?.Rate?.country ?? ''],
      ExwCity: [this.data?.Rate?.exwCity ?? ''],
      ExwRateId: [this.data?.Rate?.exwRateId ?? ''],
      FcaRateId: [this.data?.Rate?.fcaRateId ?? ''],
      FcaHarbor: [this.data?.Rate?.fcaHarbor ?? ''],
      FcaDischargeHarbor: [this.data?.Rate?.fcaDischargeHarbor ?? ''],
      CfrImportType: [this.data?.Rate?.cfrImportType ?? ''],
      CfrPrice: [this.data?.Rate?.cfrPrice ?? ''],
      CfrCurrencyType: [this.data?.Rate?.cfrCurrencyType ?? ''],

      MyIsPCT: [!(this.data?.isFixed ?? true)],
      Fixed: [this.data?.fixed ?? ''],
      Pct: [this.data?.pct ?? ''],
      MyNotes: [this.data?.MyNotes ?? ''],
      MyImporter: [this.data?.MyImporter ?? ''],
      MyCustomer: [this.data?.MyCustomer ?? ''],
      MyDisclaimer: [this.data?.MyDisclaimer ?? ''],
      MyCarPrice: [(this.data?.isFixed ?? true) ? this.data?.fixed : this.data?.pct],
      MyTaxList: [this.data?.MyTaxList ?? ''],
      MySource: [this.data?.MySource ?? ''],
      MySelection: [this.data?.MySelection ?? ''],
    });


  }

  get tableRows(): FormArray {
    return this.carForm.get('tableRows') as FormArray;
  }

  // private initializeTableRows() {
  //   // Assuming 'dataSource' is your data array
  //   this.dataSource.data.forEach(rowData => {
  //     this.tableRows.push(this._fb.group({
  //       name: [rowData.name],
  //       value: [rowData.value]
  //     }));
  //   });
  // }

  // trackByFn(index: any, item: any) {
  //     return index; // or item.id
  // }
  //
  // addRow() {
  //   this.tableRows.push(this._fb.group({ name: '', value: null }));
  // }
  //
  // removeRow(index: number) {
  //   this.tableRows.removeAt(index);
  // }

  calculateValue() {
    const MyIsPCT = this.carForm.get('MyIsPCT').value;
    const value = this.carForm.get('MyCarPrice').value;

    if (this.source === 'commercial' || (this.source === 'personal' && this.selection === 'commercial')) {
      if (MyIsPCT) {
        this.calculatedValueForCustomer = (1 + value / 100) * this.data?.C_Price;
      } else {
        this.calculatedValueForCustomer = this.data?.C_Price + value;
      }
    } else if (this.source === 'personal') {
      const sumOfTaxList = this.taxList.reduce((acc, current) => {
        return acc + (parseInt(current.value + '',  0) || 0); // If current.value is null, use 0
      }, 0);

      // debugger;
      this.calculatedValueForCustomer = (this.data?.C_Price || 0) + sumOfTaxList;
    }
  }

  saveCar(status: string) {

  }

  update() {
    const id = this.carForm.get('id').value;
    const isFixed = !this.carForm.get('MyIsPCT').value;
    const value = this.carForm.get('MyCarPrice').value || 0;
    const disclaimer = this.carForm.get('MyDisclaimer').value;
    const importer = this.carForm.get('MyImporter').value;
    const customer = this.carForm.get('MyCustomer').value;
    const notes = this.carForm.get('MyNotes').value;

    const serializedTaxList = JSON.stringify(this.taxList);


    this.carService.updateCarInMyList(id,
      isFixed,
      value,
      disclaimer,
      importer,
      notes,
      this.calculatedValueForCustomer,
      customer,
      this.source,
      this.selection,
      serializedTaxList)
      .pipe(map((res: any) => {
        if (res.code === 200) {
          const val = res.data.InsertedID;
          this.data = {...this.data, myCarId: val};
          this.messageService.add({severity: 'success', summary: 'עדכון רכב ברשימה שלי', detail: 'הצעת המחיר נשמרה בהצלחה. לצפייה בהצעות המחיר שעודכנו בחר ב "רכבים שלי" מתוך התפריט'});

          // this.messageService.add({severity: 'success', summary: 'עדכון רכב ברשימה שלי',
          // detail: 'הצעת המחיר נשמרה בהצלחה. לצפייה בהצעות המחיר שעודכנו בחר ב רכבים שלי  מתוך התפריט'});
          this.formChanged = false;
        } else {
          this.messageService.add({severity: 'danger', summary: 'עדכון רכב ברשימה שלי', detail: 'אירעה תקלה בעדכון רכב.'});

        }
      })).subscribe();
  }


  cancelCar() {
    this.nbDialogRef.close(null);
  }


  formatDate(date: string): string {
    if (!date) {
      return '';
    }
    return moment.utc(date).format('DD-MM-YYYY');
  }

  getFormattedDate(date: string): string {
    if (date === '') {
      return '';
    }
    const isoDate = new Date(date).toISOString();
    return isoDate.split('T')[0];
  }

  getWeightText(): string {
    const weight = this.carForm.get('TotalWeight').value;
    switch (weight) {
      case 1:
        return 'עד 3,500 ק"ג';
      case 2:
        return '4,500 ק"ג -3,500 ק"ג';
      case 3:
        return 'מעל ל 4,500 ק"ג';
      default:
        return ''; // or some default text
    }
  }

  handleNotify() {
    const dialogConfig = {
      hasBackdrop: true,
      closeOnEsc: true,
      backdropClass: '',
      closeOnBackdropClick: false,
      hasScroll: false,
      autoFocus: false,
      viewContainerRef: undefined,
      context: {
        source: this.importSelection,
        selection: this.selection
      }
    };

    const confirmSave = this.dialogService.open(ConfirmationSaveDialogComponent, dialogConfig);

    confirmSave.onClose.subscribe((result: any) => {
      if (result === true) {
        this.update();
      }
      // this.nbDialogRef.close();
    });
  }

  protected readonly round = round;

  isCommercial = false;
  onToggle(isCommercial: boolean): void {
    this.isCommercial = isCommercial;
    // Change color of the feature based on isCommercial
  }

  onImportTypeChange(value: string): void {
    this.selection = value as 'commercial' | 'personal';
    this.carForm.get('MySelection')?.patchValue(this.selection);
    this.carForm.get('MySelection').valueChanges.subscribe(() => {
      this.formChanged = true;
      this.calculateValue();
    });
  }

  handleListItemsChange(updatedList: TaxExpense[]): void {
    this.taxList = updatedList;
    this.carForm.get('MyTaxList')?.patchValue(updatedList);
    this.carForm.get('MyTaxList').valueChanges.subscribe(() => {
      this.formChanged = true;
      this.calculateValue();
    });
    // this.calculateValue();
  }
}
